import Backbone from 'backbone';
import { Dialog } from '@bingads-webui/dialog';
import { focusLockInstanceDecorator } from '@bingads-webui/focus-lock-decorator';
import { Success } from './success';

export default class SuccessDialog extends Backbone.View {
  initialize({
    aid,
    cid,
    uid,
    isPendingPaymentMethod,
    isAccountOnHold,
    accountPausedReason,
    lockRegionAriaLabel = '',
  }) {
    this.dialogView = new Dialog({
      className: 'campaign-creation-success-dialog',
    });
    this.successView = new Success({
      aid,
      cid,
      uid,
      isPendingPaymentMethod,
      isAccountOnHold,
      accountPausedReason,
    });
    this.dialogView.setContent(this.successView);

    const FocusLockPopupEditor = focusLockInstanceDecorator(this.dialogView, {
      onExit: () => this.dialogView.remove(),
      lockRegionAriaLabel,
      focusFirstItemOnMount: true,
    }, {
      managed: true,
    });

    this.focusLockSuccessPopupEditor = new FocusLockPopupEditor();

    this.successView.on('close', () => {
      this.dialogView.remove();
      this.focusLockSuccessPopupEditor.remove();
      this.focusLockSuccessPopupEditor = null;
    });
  }

  show() {
    this.dialogView.render();
    document.body.appendChild(this.focusLockSuccessPopupEditor.render().el);
    this.dialogView.$('.modal').modal({
      backdrop: this.dialogView.backdrop,
      keyboard: this.dialogView.keyboard,
    });
    this.dialogView.$('.modal').on('focus', () => this.dialogView.$('button.close').focus());
    return this;
  }
}
